import React, { Component } from 'react';
import DayPicker, { DateUtils } from "react-day-picker";
import 'react-day-picker/lib/style.css';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { setDate, search, getStats } from '../store/search/actions';
import moment from 'moment';

class DatePicker extends Component {

    constructor(props) {
        super(props);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
        this.handleResetClick = this.handleResetClick.bind(this);
        this.state = this.getInitialState();
      }
      getInitialState() {
        return {
          from: null,
          to: null,
          enteredTo: null, // Keep track of the last day for mouseEnter.
        };
      }
      isSelectingFirstDay(from, to, day) {
        const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
        const isRangeSelected = from && to;
        return !from || isBeforeFirstDay || isRangeSelected;
      }
      handleDayClick(day) {
        const { from, to } = this.state;
        if (from && to && day >= from && day <= to) {
          // this.handleResetClick();
          this.setState({
            from: day,
            to: null,
            enteredTo: null
          })
          return;
        }
        if (this.isSelectingFirstDay(from, to, day)) {
          this.setState({
            from: day,
            to: null,
            enteredTo: null,
          });
        } else {
          this.setState({
            to: day,
            enteredTo: day,
          });

          // set date in search options using redux
          this.props.onDateChange && this.props.onDateChange({from, to: day })

          // hide date picker after selecting from and to
          this.props.toggle();
        }
      }
      handleDayMouseEnter(day) {
        const { from, to } = this.state;
        if (!this.isSelectingFirstDay(from, to, day)) {
          this.setState({
            enteredTo: day,
          });
        }
      }
      handleResetClick() {
        this.setState(this.getInitialState());
      }
        
  render() {
    const { from, enteredTo } = this.state;
    const modifiers = { start: from, end: enteredTo };
    const disabledDays = { after: moment().toDate() };
    const selectedDays = [from, { from, to: enteredTo }];
    return (
        <DayPicker
        className="Range"
        numberOfMonths={2}
        selectedDays={selectedDays}
        disabledDays={disabledDays}
        modifiers={modifiers}
        onDayClick={this.handleDayClick}
        onDayMouseEnter={this.handleDayMouseEnter}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  
})

const mapDispatchToProps = (dispatch) => ({
  setDate: bindActionCreators(setDate, dispatch),
  search: bindActionCreators(search, dispatch),
  getStats: bindActionCreators(getStats, dispatch),
})


export default connect(mapStateToProps, mapDispatchToProps)(DatePicker);